<template>
    <div>
        <FeeDeatil :FeeDetaildiag='FeeDetaildiag' @closeFeeDetaildiag='closeFeeDetaildiag'
                   :feeCollectionId='feeCollectionId'></FeeDeatil>
        <el-dialog title='修改批次' :visible.sync='modifyFeeDialog' :close-on-click-modal='false'
                   :close-on-press-escape='false' width='400px' v-dialogDrag>
            <taxform :Formlist='modifyCollectionForm' :column='1' @getdata='updateFeeCollection' :formdata='formData'
                     ref='taxform' labelwidth='80px'>
            </taxform>
            <span slot='footer' class='dialog-footer'>
			   <el-button type='primary' @click='submitFeeCollection'>保存</el-button>
			    <el-button @click='modifyFeeDialog=false'>取消</el-button>
			  </span>
        </el-dialog>
        <div>
            <taxSearch :searchdata='search' :searchlist='searchlist' @submitSearch='query'
                       labelwidth='120px'></taxSearch>
        </div>
        <div class='end-flex' style='margin: 16px 0px 16px 0px'>
            <el-button type='primary' @click='submitMaster'>提交主流程</el-button>
            <el-button type='primary' @click="autoMergeFeeCollection">合成批次</el-button>
            <el-button type='primary' @click='mergeFeeCollection'>手动合成批次</el-button>
            <el-button type='primary' @click="deleteFeeCollections">删除批次</el-button>
        </div>
        <taxtable :headData='headData' ref='bodybox' showPagination showSelection showCountlist :countlist='countList'
                  :tableData='tableData' @sizChange='sizechange' @currentChange='currentChange'
                  @sortchange='sortchange' :pagination='pagination' :tableHeight="tableHeight">
            <template v-slot:batchNo='scope'>
                <div class='customtext' @click='fordetail(scope.taxval.id)'>
                    {{ scope.taxval.batchNo }}
                </div>
            </template>
            <template v-slot:createTime='scope'>
                {{ timestampToStr(scope.taxval.createTime) }}
            </template>
            <template v-slot:feeType='scope'>
                <div v-for='(item,index) in feeTypes' :key='index'
                     v-if='scope.taxval.feeType==item.value'>
                    {{ item.label }}
                </div>
            </template>
            <template v-slot:sourceType='scope'>
                <div v-for='(item,index) in sourceTypes' :key='index'
                     v-if='scope.taxval.sourceType==item.value'>
                    {{ item.label }}
                </div>
            </template>
            <template v-slot:mergeStatus='scope'>
                <div v-for='(item,index) in mergeStatus' :key='index'
                     v-if='scope.taxval.mergeStatus==item.value'>
                    {{ item.label }}
                </div>
            </template>
            <template v-slot:inspectionStatus='scope'>
                <div v-for='(item,index) in collectionInspStatus' :key='index'
                     v-if='scope.taxval.inspectionStatus==item.value'>
                    {{ item.label }}
                </div>
            </template>
            <template v-slot:operate='scope'>
                <el-button type='text' @click='modifyFeeCollection(scope.taxval)' v-if="scope.taxval.submitStatus!='1'">
                    修改批次
                </el-button>
                <el-button type='text' @click='deleteFeeCollection(scope.taxval.id)' v-if="scope.taxval.submitStatus!='1'">
                    删除批次
                </el-button>
            </template>
        </taxtable>
    </div>
</template>

<script>
import FeeDeatil from './FeeDetail/FeeDetail.vue';
import {
    deleteFeeCollection,
    getCurrentUserCompany, getFeeCollectionBatchInfo, getFeeCollectionInfo,
    getFeeCollectionPageList,
    mergeFeeCollection, autoMergeFeeCollection, updateFeeCollection,
    manualSubmitMainProcess, autoSubmitMainProcess
} from '../../../api/home';

export default {
    components: {
        FeeDeatil
    },
    name: 'FeeManage',
    data() {
        return {
            FeeDetaildiag: false,
            feeCollectionId: 0,
            search: {
                createTime: [],
                sourceType: '',
                companyCode: '',
                feeType: '',
                poNumber: '',
                batchNo: '',
                submitStatus: '0',
                supplierName: '',
                mergeStatus: '',
                inspectionStatus: ''
            },
            isshou: true,
            pagination: {
                pageNum: 1,
                pageSize: 300,
                total: 0,
                order: '',
                sort: '',
            },
            shaidiag: false,
            companyCodeList: [],
            modifyFeeDialog: false,
            countList: [],
            headData: [
                {
                    title: '批次号',
                    prop: 'batchNo',
                    issort: true,
                    custom: true,
                    width: 160,
                },
                {
                    title: '邮件批次号',
                    prop: 'mailBatchNo',
                    issort: true,
                    width: 160,
                },
                {
                    title: '异常说明',
                    prop: 'exceptionDesc',
                    issort: true,
                    width: 160,
                },
                {
                    title: '批次日期',
                    prop: 'createTime',
                    issort: true,
                    custom: true,
                    width: 160,
                },
                {
                    title: '公司代码',
                    prop: 'companyCode',
                    align: 'center',
                    width: 110
                },
                {
                    title: '供应商名称',
                    prop: 'supplierName',
                    width: 200
                },
                {
                    title: 'PO号',
                    prop: 'poNumber',
                    width: 160
                },
                {
                    title: '发票金额（不含税）',
                    prop: 'amount',
                    align: 'center',
                    width: 130
                },
                {
                    title: '税额',
                    prop: 'tax',
                    align: 'center',
                    width: 100
                },
                {
                    title: '发票金额（含税）',
                    prop: 'totalAmount',
                    align: 'center',
                    width: 130
                },
                {
                    title: '币种',
                    prop: 'currency',
                    align: 'center',
                    width: 100
                },
                {
                    title: '费用类型',
                    prop: 'feeType',
                    align: 'center',
                    custom: true,
                    width: 100
                },
                {
                    title: '合成状态',
                    prop: 'mergeStatus',
                    align: 'center',
                    width: 80,
                    custom: true
                },
                {
                    title: '是否全部查验通过',
                    prop: 'inspectionStatus',
                    align: 'center',
                    width: 80,
                    custom: true
                },
                {
                    title: '进件渠道',
                    prop: 'sourceType',
                    align: 'center',
                    custom: true,
                    width: 100
                },
                {
                    title: '发票数量',
                    prop: 'invoiceCount',
                    align: 'center',
                    width: 80
                },
                {
                    title: '附件数量',
                    prop: 'attachmentCount',
                    align: 'center',
                    width: 80
                },
                {
                    title: '操作',
                    prop: 'operate',
                    fixed: 'right',
                    custom: true,
                    width: 240
                }
            ],
            tableData: [],
            modifyCollectionForm: [
                {
                    prop: 'companyCode',
                    label: '公司编号',
                    type: 'select',
                    isnotnull: true,
                    selectval: []
                },
                {
                    prop: 'poNumber',
                    label: 'PO号',
                    type: 'input',
                    // isnotnull: true
                },
                {
                    prop: 'feeType',
                    label: '费用类型',
                    type: 'select',
                    isnotnull: true,
                    selectval: JSON.parse(JSON.stringify(this.feeTypes))
                },
                {
                    prop: 'currency',
                    label: '币种',
                    type: 'input'
                }
            ],
            formData: {
                companyCode: '',
                poNumber: '',
                feeType: '',
                currency: ''
            },
            searchlist: [
                {
                    type: 'date',
                    label: '批次日期',
                    valueformat: 'timestamp',
                    prop: 'createTime',
                    unlinkpanels: true
                },
                {
                    type: 'select',
                    label: '进件渠道',
                    prop: 'sourceType',
                    selectval: JSON.parse(JSON.stringify(this.sourceTypes)),
                    clearable: true
                },
                {
                    type: 'selectmore',
                    label: '公司代码',
                    prop: 'companyCode',
                    selectval: []
                },
                {
                    type: 'selectmore',
                    label: '费用类型',
                    prop: 'feeType',
                    selectval: JSON.parse(JSON.stringify(this.feeTypeList)),
                },
                {
                    type: 'input',
                    label: 'PO号',
                    prop: 'poNumber'
                },
                {
                    type: 'input',
                    label: '批次号',
                    prop: 'batchNo'
                },
                {
                    type: 'select',
                    label: '是否提交主流程',
                    prop: 'submitStatus',
                    selectval: JSON.parse(JSON.stringify(this.submitStatus)),
                    clearable: true
                },
                {
                    type: 'input',
                    label: '供应商名称',
                    prop: 'supplierName'
                },
                {
                    type: 'selectmore',
                    label: '合成状态',
                    prop: 'mergeStatus',
                    selectval: JSON.parse(JSON.stringify(this.mergeStatus))
                },
                {
                    type: 'select',
                    label: '验票成功',
                    prop: 'inspectionStatus',
                    clearable: true,
                    selectval: JSON.parse(JSON.stringify(this.collectionInspStatus))
                },
                {
                    type: 'input',
                    label: '邮件批次号',
                    prop: 'mailBatchNo'
                },
            ],
            sortField: {    //  排序的字段
                batchNo: 'batch_no',
                createTime: 'create_time'
            },
            tableHeight: 0,
            companyList: {}
        };  
    },
    created() {
        this.getCurrentUserCompany();
        this.query();
    },
    methods: {
        closeFeeDetaildiag() {
            this.FeeDetaildiag = false;
            this.query();
        },
        fordetail(id) {
            this.FeeDetaildiag = true;
            this.feeCollectionId = id;
        },
        resetClickFun() {	//	重置
            Object.keys(this.search).map(key => (this.search[key] = ''));
        },
        chageshou() {
            this.isshou = !this.isshou;
        },

        sizechange(e) {
            this.pagination.pageSize = e;
            this.query();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.query();
        },
        sortchange(data) {
            this.pagination.sort = this.sortField[data.prop];
            this.pagination.order = data.order == 'ascending' ? 'asc' : 'desc';
            this.query();
        },
        modifyFeeCollection(row) {
            this.modifyFeeDialog = true;
            this.$nextTick(() => {
                this.$refs.taxform.clearValidate();
            });
            let modifyCollectionForm = JSON.parse(JSON.stringify(this.modifyCollectionForm));
            modifyCollectionForm[0].selectval = this.companyList.map(item => {
                item.label = item.code;
                item.value = item.code;
                return item;
            });
            this.modifyCollectionForm = JSON.parse(JSON.stringify(modifyCollectionForm));
            getFeeCollectionInfo(row.id).then(res => {
                if (res.data.success) {
                    this.formData = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        updateFeeCollection(data) {
            updateFeeCollection(data).then(res => {
                if (res.data.success) {
                    this.$message.success('更新成功');
                    this.modifyFeeDialog = false;
                    this.query();
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        submitFeeCollection() {
            this.$refs.taxform.submitForm();
        },
        deleteFeeCollections() {
            var data = this.$refs.bodybox.getSelectionval();
            if(!data || data.length == 0) {
                this.$message.warning('请选择需要删除的费用批次信息！');
                return;
            }
            let idList = [];
            data.forEach(item => {
                idList.push(item.id);
            });
            this.deleteFeeCollection(idList.join(','));
        },
        deleteFeeCollection(ids) {
            this.$confirm('确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteFeeCollection(ids).then(res => {
                    if (res.data.success) {
                        this.$message.success('删除成功');
                        this.query();
                    } else {
                        this.$message.error(res.data.message);
                    }
                });
            });
        },
        getCurrentUserCompany() {
            getCurrentUserCompany().then(res => {
                let companyList = res.data.data;
                this.companyList = companyList;
                let searchList = JSON.parse(JSON.stringify(this.searchlist));
                searchList[2].selectval = companyList.map(item => {
                    item.label = item.code;
                    item.value = item.code;
                    return item;
                });
                this.searchlist = JSON.parse(JSON.stringify(searchList));
                console.log(this.searchList);
            });
        },
        query() {
            let newSearch = JSON.parse(JSON.stringify(this.search))
            if(!newSearch.companyCode || newSearch.companyCode.length == 0) {
                newSearch.companyCode = ''
            }
            this.pagination.search = newSearch;
            // this.pagination.page = this.pagination.pageNum;
            // this.pagination.limit = this.pagination.pageSize;
            getFeeCollectionPageList(this.pagination).then(res => {
                this.tableData = res.data.data.records;
                this.pagination.total = res.data.data.total;
                let invoiceCount = 0;
                let attachmentCount = 0;
                this.tableData.forEach((item, index) => {
                    invoiceCount += parseInt(item.invoiceCount);
                    attachmentCount += parseInt(item.attachmentCount);
                });
                this.countList = [
                    {
                        'label': '发票数量',
                        'value': invoiceCount
                    },
                    {
                        'label': '附件数量',
                        'value': attachmentCount
                    }
                ];

            });
        },
        submitMaster() {
            var data = this.$refs.bodybox.getSelectionval();
            if(data && data.length > 0) {
                let idList = [];
                data.forEach(item => {
                    idList.push(item.id);
                });
                manualSubmitMainProcess(idList.join(',')).then(res => {
                    if(res.data.success) {
                        if(res.data.message) {
                            this.$message.warning(res.data.message);
                        } else {
                            this.$message.success('提交主流程成功！');
                        }
                        this.query();
                    } else {
                        this.$message.error('提交主流程失败：' + res.data.message);
                    }
                });
            } else {
                autoSubmitMainProcess().then(res => {
                    if(res.data.success) {
                        if(res.data.message) {
                            this.$message.warning(res.data.message);
                        } else {
                            this.$message.success('提交主流程成功！');
                        }
                        this.query();
                    } else {
                        this.$message.error('提交主流程失败：' + res.data.message);
                    }
                });
            }    
        },
        mergeFeeCollection() {
            let ids = [];
            let data = this.$refs.bodybox.getSelectionval();
            data.forEach((item, index) => {
                ids.push(item.id);
            });
            mergeFeeCollection(ids.join(',')).then(res => {
                if (res.data.success) {
                    this.$message.success('合并成功');
                    this.query();
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        autoMergeFeeCollection() {
            autoMergeFeeCollection().then(res => {
                if(res.data.success) {
                    this.$message.success("合并成功");
                    this.query();
                } else {
                    this.$message.error("合并失败：" + res.data.message);
                }
            });
        },
        repairtable() {
            this.$nextTick(() => {
                this.tableHeight = this.diagheightshenghe();
                setTimeout(() => {
                    this.$refs.multipleTable.doLayout();
                }, 300);
                window.onresize = () => {
                    this.tableHeight = this.diagheightshenghe();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 300);
                };
            });
        }
    },
    mounted() {
        this.repairtable()
    }
};
</script>

<style scoped lang='less'>
.maxheight {
    height: 150px;
}
</style>